import { useMemo } from 'react';
import type { PlaylistDesign__PlaylistItem as PlaylistItem } from '../../index.generated';

export const useOrderedItems = (order: readonly number[], items: readonly PlaylistItem[] = []) => {
  const index = useMemo(() => new Map(items.map((x) => [x.id, x])), [items]);

  const orderedItems = useMemo(
    () => order.map((id) => index.get(id)).filter((i): i is PlaylistItem => Boolean(i)),
    [order, index],
  );

  return { orderedItems };
};
